import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';

const ModalbtaEmpresa = ({ plan, total, posicion, onEliminarPlan }) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <div style={{ margin: '5px' }}>
      <Button onClick={toggle} className="close">
        <span aria-hidden="true">×</span>
      </Button>
      <Modal isOpen={modal} toggle={toggle} className={''}>
        <ModalHeader toggle={toggle} />
        <ModalBody>
          <div className="title-delete-btaemp">¿Estás seguro de eliminar?</div>
          <div className="box-delete-temsbta-emp">
            <Row>
              <div className="col-sm-8">
                <div className="title-option-deletebta font-futura-medium">
                  {plan?.planNombre}
                </div>
                <div
                  className="detail-opcion-deletebta font-source-sans-pro-semi-bold mt-"
                  style={{ fontSize: '17px' }}
                >
                  {plan?.diasNumero} Días
                </div>
              </div>
              <div className="col-sm-4 mt-3">
                <div className="price-opcion-deletebta font-source-sans-pro-semi-bold">
                  {total}
                </div>
              </div>
            </Row>
          </div>
          <Row>
            <div className="col-sm-6">
              <Button className="btn-atras-api text-mex" onClick={toggle}>
                Cancelar
              </Button>
            </div>
            <div className="col-sm-6">
              <Button
                className="btn-siguiente-api"
                onClick={() => {
                  onEliminarPlan({ posicion });
                  toggle();
                }}
              >
                Eliminar
              </Button>
            </div>
          </Row>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ModalbtaEmpresa;
